var _defs, _path, _path2, _path3, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErroPrimeiroAcesso(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "76px",
    viewBox: "0 0 91 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E0A3BAB7-4BD0-4EF5-8620-CE50825185AE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9991299%",
    y1: "2.04313674%",
    x2: "49.9991299%",
    y2: "98.5656796%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EBD0",
    stopOpacity: 0,
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.15,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Vers\\xE3o-RESPONSIVA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0.2-Erro---Usu\\xE1rio-n\\xE3o-encontrado-",
    transform: "translate(-162.000000, -79.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vetor_Sombra",
    transform: "translate(162.000000, 80.000000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2414583,8.24524781 L22.7521291,8.24524781 C20.2274685,8.2470608 17.8912448,9.56222572 16.6068547,11.7047005 L0.993973591,37.7873129 C-0.33132453,39.9921199 -0.33132453,42.7338591 0.993973591,44.9386661 L16.6068547,71.0349522 C17.8884917,73.1810708 20.2256831,74.4993807 22.7521291,74.5012391 L54.2414583,74.5012391 C56.7700068,74.500418 59.1097553,73.1821537 60.3936687,71.0349522 L76.0065498,44.9386661 C77.3243865,42.7318495 77.3243865,39.9941295 76.0065498,37.7873129 L60.3936687,11.6841899 C59.1008111,9.54952411 56.7636314,8.2430962 54.2414583,8.24524781 Z",
    id: "Path",
    fill: "#465EFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.2414583,8.24524781 L22.7521291,8.24524781 C20.2274685,8.2470608 17.8912448,9.56222572 16.6068547,11.7047005 L0.993973591,37.7873129 C-0.33132453,39.9921199 -0.33132453,42.7338591 0.993973591,44.9386661 L16.6068547,71.0349522 C17.8884917,73.1810708 20.2256831,74.4993807 22.7521291,74.5012391 L54.2414583,74.5012391 C56.7700068,74.500418 59.1097553,73.1821537 60.3936687,71.0349522 L76.0065498,44.9386661 C77.3243865,42.7318495 77.3243865,39.9941295 76.0065498,37.7873129 L60.3936687,11.6841899 C59.1008111,9.54952411 56.7636314,8.2430962 54.2414583,8.24524781 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8346748,17.2767362 L24.9993852,17.2767362 C24.3804705,17.2755236 23.8074339,17.5982937 23.4942785,18.1245099 L10.1078455,40.522056 C9.78922575,41.0632002 9.78922575,41.7311474 10.1078455,42.2722916 L23.4942785,64.649327 C23.8074339,65.1755432 24.3804705,65.4983134 24.9993852,65.4971008 L51.8346748,65.4971008 C52.4535894,65.4983134 53.0266261,65.1755432 53.3397815,64.649327 L66.7262144,42.2722916 C67.0522389,41.7331348 67.0522389,41.0612128 66.7262144,40.522056 L53.3397815,18.1450205 C53.0319081,17.6109101 52.457878,17.2797579 51.8346748,17.2767362 L51.8346748,17.2767362 Z",
    id: "Path",
    stroke: "#54DCFC",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3050254,56.9305146 C35.7110755,56.3664196 35.3840454,55.5828449 35.4033486,54.7700676 C35.3799893,53.9303598 35.7090971,53.1183476 36.3130061,52.5256568 C36.9169151,51.9329661 37.7421258,51.6121026 38.5938974,51.6387867 C39.4456827,51.612452 40.2717835,51.9282999 40.8827693,52.5139045 C42.1092473,53.72992 42.1092473,55.6939886 40.8827693,56.9100041 C39.6003868,58.0918439 37.6082159,58.0918439 36.3258333,56.9100041 L36.3050254,56.9305146 Z M40.5775864,48.3912793 L36.6171443,48.3912793 L36.0414583,26.9714039 L41.1047205,26.9714039 L40.5775864,48.3912793 Z",
    id: "Shape",
    fill: "#F9F930",
    fillRule: "nonzero"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 70.8531199,
    y1: 12.0807277,
    x2: 74.7303303,
    y2: 0,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6214126,
    y1: 24.9203466,
    x2: 90.3085315,
    y2: 27.3679416,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 74.5153151,
    y1: 18.1313468,
    x2: 87.0278151,
    y2: 11.0825464,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErroPrimeiroAcesso);
export default __webpack_public_path__ + "static/media/iconErroPrimeiroAcesso.b37e97d2f9003efdad03a2af60d954b8.svg";
export { ForwardRef as ReactComponent };